<template>
  <div>
    <m-page-header :title="$t(`apply.title.infoFill`)"></m-page-header>
    <m-form ref="form">
      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            is-form-item
            :maxLength="200"
            :disabled="form.isReissue"
            v-model="form.siteName"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="this.$t(`apply.title.venueName`)"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20" >
          <m-input
            is-form-item
            :maxLength="50"
            v-model="form.staffNum"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="this.$t(`apply.title.staffNumber`)"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
              {
                pattern: /^[0-9]+$/,
                message: this.$t('Common.title.formatError'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>
      <m-row :gutter="24">
        <m-col span="20">
          <m-input
            ref="address"
            is-form-item
            :maxLength="200"
            v-model="form.siteAddress"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="$t(`apply.title.venueLocation`)"
            :rules="[
              {
                required: true,
                message: $t(`Common.message.required`),
              },
            ]"
          ></m-input>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20">
          <m-date-picker
            is-form-item
            :disabledDate="disabledDate"
            v-model="form.openDateStr"
            format="YYYY-MM-DD"
            :label="this.$t('apply.title.openDate')"
            :placeholder="this.$t('Common.message.validDateTip')"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
            ]"
          >
          </m-date-picker>
        </m-col>
      </m-row>

      <m-row :gutter="24">
        <m-col span="20" >
          <m-input
            is-form-item
            :maxLength="50"
            v-model="form.businessHours"
            :placeholder="$t('Common.message.pleaseEnter')"
            :label="this.$t(`apply.title.businessTime`)"
            :rules="[
              {
                required: true,
                message: this.$t('Common.message.required'),
              },
            ]"
          >
          </m-input>
        </m-col>
      </m-row>
      <!-- <m-row :gutter="24">
        <m-col span="20" style="padding-left: 0px">
          <div
            style="
              flex-direction: row;
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 30%; margin-right: 22px;">
              <label class="required-label">
                {{ this.$t('apply.title.businessTime') }}
              </label>
            </div>
            <div 
            style="
              flex-direction: column;
              display: flex;
              width: 70%;
            "
          >
            <m-time-picker
              :class="showError ? 'borderColorError' : 'borderColor'"              
              style="width: 100%;"
              v-model="form.businessTimeStr"
              format="HH:mm"
              :placeholder="this.$t('Common.message.selTime')"
              required
              :rules="[
                {
                  required: true,
                  message: this.$t('Common.message.required'),
                },
              ]"
              @change="validateTime"
            />
            <div v-if="showError" class="error-message">
              {{ this.$t('Common.message.required') }}
            </div>
          </div>
          </div>
        </m-col>
      </m-row> -->
    </m-form>
  </div>
</template>
  <script>
import { addressMixin } from 'common/components/Address/web/address';
import { dayFormat, disabledDate } from 'govmo-common/src/utils/utils';

export default {
  mixins: [addressMixin],
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      showError: false,
    };
  },
  methods: {
    disabledDate,
    onPrevious() {
      this.$emit('previous');
    },
    async onNext() {
      try {
        if (this.form.businessTimeStr) {
          this.showError = false;
        } else {
          this.showError = true;
        }
        if (!(await this.$refs.form.validateFields()) || !this.showError) return;
        this.$set(this.form, 'openDate', dayFormat(this.form.openDateStr));
        // this.$set(this.form, 'siteAddress', this.form.venueLocation?.fullAddress)
        this.$emit('next', this.form);
      } catch (error) {
        return;
      }
    },
    // validateTime() {
    //   if (this.form.businessTimeStr) {
    //       this.showError = false;
    //     } else {
    //       this.showError = true;
    //     }
    // },
    async handleValidate() {
      this.$refs.venueLocation.handleValidate();
    },
  },
  async created() {
    this.form = {
      ...this.formData,
      // documentTypes: [{ nameCn: 'name1' }, { nameCn: 'name2' }],
    };
    console.log('====2', this.formData);
  },
};
</script>
<style lang="scss" scoped>
.required-label::before {
  content: '*';
  color: red;
}
/* 错误提示样式 */
.error-message {
  color: red;
  font-size: 16px;
  margin-top: 4px;
}
.borderColorError :deep(.ant-time-picker-input) {
  border-color: #f5222d !important;
}
.borderColor :deep(.ant-time-picker-input) {
  border-color: #c1c1c1;
}
</style>
  